import { all, call, put, takeLatest } from "redux-saga/effects";
import { login, loginSuccess, loginFailure } from "./authenticationSlice";
import { postRequest } from "app/axiosClient";
import { message } from "antd";

function* loginAPI(action) {
  try {
    const response = yield call(() =>
      postRequest("api/Accounts/Login", action.payload)
    );
    yield put(loginSuccess(response.data));
    message.success("Login sucessful");
  } catch (e) {
    yield put(loginFailure());
    message.warning("Invalid username or password");
  }
}

export default function* rootSaga() {
  yield all([takeLatest(login, loginAPI)]);
}
